import styled from 'styled-components';

export const Titulo = styled.h2`
  margin-bottom: 1.5rem;
  color: #343a40;
  font-weight: 600;
`;

export const InfoCard = styled.div`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1rem;
  height: 100%;

  h5 {
    margin: 0 0 1rem 0;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #dee2e6;
    color: #495057;
    font-weight: 600;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.span`
  font-weight: 600;
  color: #495057;
  min-width: 100px;
  margin-right: 0.5rem;
`;

export const InfoValue = styled.span`
  color: #212529;
  flex: 1;
`;

export const ActionsBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: 2rem 0;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
`;

export const MedicamentosSection = styled.div`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-top: 1.5rem;
`;
